module.exports = __webpack_public_path__ + "static/media/logoerp.956ec0dc.png";